
        Component.define('youbuy-sell', (el, params) => {
            /**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */

const $el            = $(el);
const $form          = $el.find('form');
const $tabLink       = $el.find('[data-tab]');
const $tabLinkHeader = $el.find('.nav-tabs a');

$form.parsley();

$tabLink.on('click', function() {
    const $group     = $('.first-group');
    const $this      = $(this);
    let successCount = 0;
    const groupSize  = $group.size();

    $form.trigger('submit');

    $('.first-group').each(function() {
      if ($(this).val() != '') {
          successCount++;
      }
    });

    if (groupSize == successCount) {
        const tabOn = $this.data('tab');

        if (tabOn == 'contato') {
            $form.addClass('step-two');
        }

        if (tabOn == 'aeronave') {
            $form.removeClass('step-two');
        }

        $el
        .find('.tab')
        .add($tabLinkHeader)
        .removeClass('active');

        $el
        .find('.tab[data-target-tab="' + tabOn + '"]')
        .add($el.find('[data-header-tab="' + tabOn + '"]'))
        .addClass('active');
    }
});

$('#add-photo').on('click', function() {
    $('.file').append('<input type=\"file\" name=\"photos[]\" />');
});

        });